function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { Emitter } from '@okee-uikit/react-hooks';
import { guid } from '@okee-uikit/react-utils';
export var OptionGroup = function (_Emitter) {
  _inherits(OptionGroup, _Emitter);

  var _super = _createSuper(OptionGroup);

  function OptionGroup(select, id, optionGroup) {
    var _this;

    _classCallCheck(this, OptionGroup);

    _this = _super.call(this);
    _this.parent = null;
    _this.optionMap = {};
    _this.groupMap = {};
    _this.title = '';
    _this.disposed = false;
    _this.select = select;
    _this.id = id || guid();
    _this.parent = optionGroup || null;

    _this.select.registerOptionGroup(_assertThisInitialized(_this));

    if (_this.parent) {
      _this.parent.registerOptionGroup(_assertThisInitialized(_this));
    }

    return _this;
  }

  _createClass(OptionGroup, [{
    key: "dispose",
    value: function dispose() {
      if (this.disposed) {
        return;
      }

      this.select.unregisterOptionGroup(this);

      if (this.parent) {
        this.parent.unregisterOptionGroup(this);
      }

      this.groupMap = {};
      this.disposed = true;
    }
  }, {
    key: "updateOptionGroupOptions",
    value: function updateOptionGroupOptions(options) {
      this.title = options.title;
    }
  }, {
    key: "registerOption",
    value: function registerOption(option) {
      var id = option.getId();

      if (this.optionMap[id]) {
        throw new Error("id=".concat(id, " option component has been registered"));
      }

      this.optionMap[id] = option;
    }
  }, {
    key: "unregisterOption",
    value: function unregisterOption(option) {
      var id = option.getId();

      if (!this.optionMap[id]) {
        throw new Error("id=".concat(id, " option component dose not been registered"));
      }

      delete this.optionMap[id];
    }
  }, {
    key: "registerOptionGroup",
    value: function registerOptionGroup(optionGroup) {
      var id = optionGroup.getId();

      if (this.optionMap[id]) {
        throw new Error("id=".concat(id, " optionGroup component has been registered"));
      }

      this.groupMap[id] = optionGroup;
    }
  }, {
    key: "unregisterOptionGroup",
    value: function unregisterOptionGroup(optionGroup) {
      var id = optionGroup.getId();

      if (!this.groupMap[id]) {
        throw new Error("id=".concat(id, " optionGroup component dose not been registered"));
      }

      delete this.groupMap[id];
    }
  }, {
    key: "getOptionIdPath",
    value: function getOptionIdPath() {
      var path = [this.id];

      if (!this.parent) {
        return path;
      }

      return this.parent.getOptionIdPath().concat(path);
    }
  }, {
    key: "isGroup",
    value: function isGroup() {
      return false;
    }
  }, {
    key: "getId",
    value: function getId() {
      return this.id;
    }
  }, {
    key: "getTitle",
    value: function getTitle() {
      return this.title;
    }
  }]);

  return OptionGroup;
}(Emitter);